<ng-container *ngIf="vm$ | async as vm">
    <div class="row">
        <div class="col-xs-12 pb-35">
            <h4>Draft and Active Campaigns</h4>
            <div role="group" aria-label="Draft and Active Campaigns Table">
                <kendo-grid id="draft-active-grid"
                            [navigable]="true"
                            class="no-vertical-scrollbar"
                            [data]="vm.activeGridData">

                    <kendo-grid-column media="(max-width: 800px)" title="Draft and Active Campaigns">
                        <!-- template for mobile -->
                        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" let-item>
                            <dl>
                                <dt>Start Date</dt>
                                <dd>
                                    <span id="startDt-{{rowIndex}}">{{dataItem.startDt | date: 'MM/dd/yyyy'}}</span>
                                </dd>
                            </dl>
                            <dl>
                                <dt>End Date</dt>
                                <dd>
                                    <span id="endDt-{{rowIndex}}">{{dataItem.endDt | date: 'MM/dd/yyyy'}}</span>
                                </dd>
                            </dl>
                            <dl>
                                <dt>Status</dt>
                                <dd>
                                    <span id="status-{{rowIndex}}">{{dataItem.status === 'Open' ? 'Active' : dataItem.status}}</span>
                                </dd>
                            </dl>
                            <dl>
                                <dt>Dollars Raised</dt>
                                <dd>
                                    <span id="dollarsRaised-{{rowIndex}}">
                                        {{dataItem.dollarsRaised | currency:'USD':'symbol':'1.0-2'}}
                                    </span>
                                </dd>
                            </dl>
                            <dl>
                                <dt>Sponsors</dt>
                                <dd>
                                    <span id="sponsors-{{rowIndex}}">{{dataItem.sponsors}}</span>
                                </dd>
                            </dl>
                            <dl>
                                <dt>Campaign Url</dt>
                                <dd>
                                    <span id="campaignUrl-{{rowIndex}}"><u>{{dataItem.campaignUrl}}</u></span>
                                </dd>
                            </dl>

                            <dl>
                                <dt class="btn-right">
                                    <button id="edit-btn-{{rowIndex}}"
                                            aria-label="Edit"
                                            title="Edit"
                                            kendoButton
                                            class="icon-button"
                                            #btn
                                            (click)="editCampaign(dataItem.campaignId, dataItem.verifiedStudentId)">
                                        <i class="fas fa-pencil fa-2x"></i>
                                    </button>

                                </dt>
                            </dl>
                        </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-column title="Start Date"
                                       field="startDt"
                                       [headerStyle]="{'text-align':'left', 'width': '10%'}"
                                       [style]="{'text-align':'left', 'width':'10%'}"
                                       media="(min-width: 800px)">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem.startDt | date: 'MM/dd/yyyy'}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="End Date"
                                       field="endDt"
                                       [headerStyle]="{'text-align':'left', 'width': '10%'}"
                                       [style]="{'text-align':'left', 'width':'10%'}"
                                       media="(min-width: 800px)">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem.endDt | date: 'MM/dd/yyyy'}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Status"
                                       field="status"
                                       [headerStyle]="{'text-align':'left', 'width': '10%'}"
                                       [style]="{'text-align':'left', 'width':'10%'}"
                                       media="(min-width: 800px)">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem.status === 'Open' ? 'Active' : dataItem.status}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Dollars Raised"
                                       field="dollarsRaised"
                                       [headerStyle]="{'text-align':'left', 'width': '10%'}"
                                       [style]="{'text-align':'left', 'width':'10%'}"
                                       media="(min-width: 800px)">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem.dollarsRaised | currency:'USD':'symbol':'1.0-2'}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Sponsors"
                                       field="sponsors"
                                       [headerStyle]="{'text-align':'left', 'width': '10%'}"
                                       [style]="{'text-align':'left', 'width':'10%'}"
                                       media="(min-width: 800px)">
                    </kendo-grid-column>
                    <kendo-grid-column title="Campaign Url"
                                       field="campaignUrl"
                                       [headerStyle]="{'text-align':'left', 'width': '40%'}"
                                       [style]="{'text-align':'left', 'width':'40%'}"
                                       media="(min-width: 800px)">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <u>{{dataItem.campaignUrl}}</u>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Edit"
                                       [headerStyle]="{'text-align':'center', 'width': '10%'}"
                                       [style]="{'text-align':'center', 'width':'10%'}"
                                       media="(min-width: 800px)">
                        <ng-template kendoGridCellTemplate let-item let-rowIndex="rowIndex">
                            <button id="btn-edit-{{rowIndex}}" kendoGridFocusable role="gridcell" kendoButton class="icon-button" (click)="editCampaign(item.campaignId, item.verifiedStudentId)" title="Edit"><i class="fas fa-pencil fa-2x"></i></button>
                        </ng-template>
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-xs-12">
            <h4>Completed and Archived Campaigns</h4>
            <div role="group" aria-label="Completed and Archived Campaigns Table">
                <kendo-grid id="draft-active-grid"
                            [data]="vm.completedGridData"
                            [pageable]="{ pageSizes: [10,25,50] }"
                            [pageSize]="vm.completed.state.take"
                            [skip]="vm.completed.state.skip"
                            [navigable]="true"
                            class="no-vertical-scrollbar"
                            (dataStateChange)="completedDataStateChange($event)">

                    <kendo-grid-column media="(max-width: 800px)" title="Completed and Archived Campaigns">
                        <!-- template for mobile -->
                        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" let-item>
                            <dl>
                                <dt>Start Date</dt>
                                <dd>
                                    <span id="startDt-{{rowIndex}}">{{dataItem.startDt | date: 'MM/dd/yyyy'}}</span>
                                </dd>
                            </dl>
                            <dl>
                                <dt>End Date</dt>
                                <dd>
                                    <span id="endDt-{{rowIndex}}">{{dataItem.endDt | date: 'MM/dd/yyyy'}}</span>
                                </dd>
                            </dl>
                            <dl>
                                <dt>Status</dt>
                                <dd>
                                    <span id="status-{{rowIndex}}">{{dataItem.status === 'Open' ? 'Active' : dataItem.status}}</span>
                                </dd>
                            </dl>
                            <dl>
                                <dt>Dollars Raised</dt>
                                <dd>
                                    <span id="dollarsRaised-{{rowIndex}}">
                                        {{dataItem.dollarsRaised | currency:'USD':'symbol':'1.0-2'}}
                                    </span>
                                </dd>
                            </dl>
                            <dl>
                                <dt>Sponsors</dt>
                                <dd>
                                    <span id="sponsors-{{rowIndex}}">{{dataItem.sponsors}}</span>
                                </dd>
                            </dl>
                            <dl>
                                <dt>Campaign Url</dt>
                                <dd>
                                    <span id="campaignUrl-{{rowIndex}}"><u>{{dataItem.campaignUrl}}</u></span>
                                </dd>
                            </dl>
                            <dl>
                                <dt class="btn-right">
                                    <button id="view-btn-{{rowIndex}}"
                                            aria-label="View"
                                            kendoButton
                                            class="icon-button"
                                            #btn
                                            (click)="goToCampaign(dataItem.campaignId)">
                                        <i class="fas fa-binoculars fa-2x"></i>
                                    </button>

                                </dt>
                            </dl>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Start Date"
                                       field="startDt"
                                       [headerStyle]="{'text-align':'left', 'width': '10%'}"
                                       [style]="{'text-align':'left', 'width':'10%'}"
                                       media="(min-width: 800px)">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem.startDt | date: 'MM/dd/yyyy'}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="End Date"
                                       field="endDt"
                                       [headerStyle]="{'text-align':'left', 'width': '10%'}"
                                       [style]="{'text-align':'left', 'width':'10%'}"
                                       media="(min-width: 800px)">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem.endDt | date: 'MM/dd/yyyy'}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Status"
                                       field="status"
                                       [headerStyle]="{'text-align':'left', 'width': '10%'}"
                                       [style]="{'text-align':'left', 'width':'10%'}"
                                       media="(min-width: 800px)">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem.status === 'Open' ? 'Active' : dataItem.status}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Dollars Raised"
                                       field="dollarsRaised"
                                       [headerStyle]="{'text-align':'left', 'width': '10%'}"
                                       [style]="{'text-align':'left', 'width':'10%'}"
                                       media="(min-width: 800px)">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem.dollarsRaised | currency:'USD':'symbol':'1.0-2'}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Sponsors"
                                       field="sponsors"
                                       [headerStyle]="{'text-align':'left', 'width': '10%'}"
                                       [style]="{'text-align':'left', 'width':'10%'}"
                                       media="(min-width: 800px)">
                    </kendo-grid-column>
                    <kendo-grid-column title="Campaign Url"
                                       field="campaignUrl"
                                       [headerStyle]="{'text-align':'left', 'width': '40%'}"
                                       [style]="{'text-align':'left', 'width':'40%'}"
                                       media="(min-width: 800px)">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <u>{{dataItem.campaignUrl}}</u>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="View"
                                       [headerStyle]="{'text-align':'center', 'width': '10%'}"
                                       [style]="{'text-align':'center', 'width':'10%'}"
                                       media="(min-width: 800px)">
                        <ng-template kendoGridCellTemplate let-item let-rowIndex="rowIndex">
                            <button id="btn-view-{{rowIndex}}" kendoGridFocusable role="gridcell" kendoButton class="icon-button" (click)="goToCampaign(item.campaignId)"><i class="fas fa-binoculars fa-2x"></i></button>
                        </ng-template>
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
    </div>
</ng-container>